import { types, isType } from "mobx-state-tree"
import { getAllLeagues, getLeaguesByCategoryId, getSingleLeague } from "../api-calls/leagues"
import { getEventsByLeagueId } from "../api-calls/events"

import { League } from "../models/League";
import { Event } from "../models/Event";


const LeagueStoreModel = types
    .model('LeagueStore', {
        loading: types.boolean,
        loaded: types.boolean,
        leagues: types.map(League),
        leagueEvents: types.map(Event),
        categoryLeagues: types.map(League),
        singleLeague: types.map(League)

    })
    .views(self => {
        return {
        // View Here
        }
    })
    .actions(self => {
        return {
            queryLeagues: async () => {
                self.loading = true;
                self.loaded = false;
                getAllLeagues().then((leagues) => {
                    self.setLeagues(leagues);
                    self.setLoading(false);
                    self.setLoaded(true);
                });
                return self.leagues;
            },
            setLeagues: (leagues) => {
                for (let league of leagues) {
                    self.leagues.put(league);
                }
            },
            queryLeagueEvents: async (leagueId) => {
                self.resetLeagueEvents();
                getEventsByLeagueId(leagueId).then((events) => {
                    self.setLeagueEvents(events);
                });
                return self.leagues;
            },
            setLeagueEvents: (events) => {
                for (let event of events) {
                    self.leagueEvents.put(event);
                }
            },
            queryCategoryLeagues: async (categoryId) => {
                self.resetCategoryLeagues();
                getLeaguesByCategoryId(categoryId).then((leagues) => {
                    self.setCategoryLeagues(leagues);
                });
            },
            setCategoryLeagues: (leagues) => {
                for (let league of leagues) {
                    self.categoryLeagues.put(league);
                }
            },
            querySingleLeague: async (leagueId) => {
                self.resetSingleLeague();
                getSingleLeague(leagueId).then((league) => {
                    self.setSingleLeague(league);
                });
            },
            setSingleLeague: (league) => {
                    self.singleLeague.put(league);
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            resetCategoryLeagues: () => {
                self.categoryLeagues = {}
            },
            resetLeagueEvents: () => {
                self.leagueEvents = {}
            },
            resetSingleLeague: () => {
                self.singleLeague = {}
            }

        }
    });

const LeagueStore = LeagueStoreModel.create({
    loaded: false,
    loading: false,
    leagues: {},
    leagueEvents: {},
    categoryLeagues: {},
    singleLeague: {}
    
});

export default LeagueStore;


// WEBPACK FOOTER //
// ./src/stores/LeagueStore.js